import { AxiosError } from 'axios';
import { useGet } from 'lib/swr-crud';
import { APIErrorResponse } from 'lib/utils';
import {
  getOrdersByUserId,
  GetOrdersByUserIdOption,
  GetOrdersByUserIdResponse,
  getOrdersByUserIdUrl,
} from './api';

const useUserOrders = (
  userId: string | null,
  params?: GetOrdersByUserIdOption,
) => {
  const shouldFetch = userId !== null;
  const url = shouldFetch
    ? getOrdersByUserIdUrl(userId, params)
    : null;

  const { data, error, isLoading, mutate } = useGet<
    GetOrdersByUserIdResponse,
    AxiosError<APIErrorResponse>
  >(url, async () => await getOrdersByUserId(userId!, params));

  const mutateOrders = (updater) =>
    mutate((data) => ({
      ...data,
      data: updater(data?.data),
    }));

  const orders = data?.data ?? [];
  const total = data?.meta?.total ?? 0;
  const currentPage = data?.meta?.current_page ?? 0;

  return {
    orders,
    total,
    currentPage,
    error,
    isLoading,
    mutate: mutateOrders,
  };
};

export default useUserOrders;
